export default "__VITE_ASSET__BzcM9G1s__"